export const initializeMobileInterface = () => {
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.logHandler) {
    const originalLog = console.log;
    console.log = (...args: unknown[]) => {
      window.webkit?.messageHandlers.logHandler.postMessage(args.join(', '));
      originalLog(...args);
    };
  }
};
